import { render } from "./TableTax.vue?vue&type=template&id=3cfd8696&scoped=true&ts=true"
import script from "./TableTax.vue?vue&type=script&lang=ts"
export * from "./TableTax.vue?vue&type=script&lang=ts"

import "./TableTax.vue?vue&type=style&index=0&id=3cfd8696&lang=scss&scoped=true"

import exportComponent from "/builds/Chirbou/isolation/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cfd8696"]])

export default __exports__